import Modal from 'react-bootstrap/Modal';
import { forwardRef, useEffect } from 'react';
import { connect } from 'react-redux';
// import { toastr } from 'react-redux-toastr';
import { inject, observer } from 'mobx-react';
import VehicleForm from '../../../vehicles/components/VehicleForm';
import { vehicleActions } from '../../../vehicles/store/vehicleStore';

import * as actions from '../../../insurances/store/actions';
// import APPConf from '../../../../lib/config/common';
import VehiclePolicies from './VehiclePolicies';
import { setZIndexForModalForms } from '../../../../lib/functions';
// Не удаляй комментарий ниже
// Заготовка для перехода на TS
// При переходе на React 19 решил не рисковать, отдельно сделаем переход на TS
// interface VehicleModalProps {
//   show?: boolean
//   onChange?(...args: unknown[]): unknown
//   onHide?(...args: unknown[]): unknown
//   title?: string
//   onReset?(...args: unknown[]): unknown
//   onSubmit?(...args: unknown[]): unknown
//   initialValues?: object
//   clientId?: string
//   vehicleId?: string
//   readOnly?: boolean
//   createVehicleInsurancePolicy?(...args: unknown[]): unknown
//   updateVehicleInsurancePolicy?(...args: unknown[]): unknown
//   deleteVehicleInsurancePolicy?(...args: unknown[]): unknown
//   order?: object
//   partnerServices?: unknown[]
//   clientMode?: boolean
//   lightMode?: boolean
//   // показываем сокращённое количество полей
//   serviceId?: number
//   vinRequired?: boolean
// }

const VehicleModal = forwardRef<HTMLElement>((props, ref) => {
  const {
    show,
    onHide,
    title,
    onReset,
    onSubmit,
    initialValues,
    clientId,
    serviceId,
    vehicleId,
    readOnly,
    createVehicleInsurancePolicy,
    updateVehicleInsurancePolicy,
    deleteVehicleInsurancePolicy,
    // order,
    // partnerServices,
    vehicleStore,
    onChange,
    clientMode,
    vinRequired = false,
    lightMode = true,
  } = props;

  const { policies } = vehicleStore;

  // const serviceData = partnerServices?.find(s => s.id === order?.serviceId);

  const handlePoliciesOnSubmit = async (data) => {
    // let result = [];

    if (policies.length > 0 && data?.id) {
      await Promise.allSettled(policies
        .filter(v => v.created || v.updated || v.deleted)
        .map(p => (
          // eslint-disable-next-line no-nested-ternary
          p.created
            ? createVehicleInsurancePolicy({ ...p, vehicleId: data?.id })
            : (p.updated
              ? updateVehicleInsurancePolicy({ ...p })
              : deleteVehicleInsurancePolicy({ ...p }))
        )))
        .then(() => {
          vehicleActions.clearChangedPolicies();
          vehicleActions.getPolicies(vehicleId);
        });
      /*  const errored = result.filter(r => r.status === 'rejected');

      if (errored.length > 0) {
        toastr.error(APPConf.errorHdr, errored.map(e => e.reason).join('; '));

        return null;
      } */
    }

    return null;
    /* result
      .filter(r => r.status === 'fulfilled' && r.value?.payload?.createdPolicies)
      .map(r => r.value.payload.createdPolicies); */
  };

  const handleSubmit = async (data) => {
    const createdPolicies = await handlePoliciesOnSubmit(data);

    if (typeof onSubmit === 'function') {
      await onSubmit(data, createdPolicies);
    }
  };

  useEffect(() => {
    setZIndexForModalForms();
  }, []);

  return (
    <Modal
      show={ show }
      backdrop='static'
      size='xl'
      aria-labelledby='modal-vehicle-new'
      dialogClassName='modal-vehicle-new'
      onHide={ onHide }
    >
      <Modal.Header>
        <Modal.Title id='modal-vehicle-new'>
          { title }
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <VehicleForm
          initialValues={ initialValues }
          clientId={ clientId }
          vehicleId={ vehicleId }
          onReset={ onReset }
          onSubmit={ handleSubmit }
          ref={ ref }
          readOnly={ readOnly }
          onChange={ onChange }
          lightMode = { lightMode }
          serviceId={ serviceId }
          vinRequired={ vinRequired }
        >
          { !readOnly && vehicleId && (
            <VehiclePolicies
              vehicleId={ clientMode ? vehicleId : null }
            />
          ) }
        </VehicleForm>
      </Modal.Body>
    </Modal>
  );
});

VehicleModal.displayName = 'VehicleModal';

const mapStateToProps = state => ({
  partnerServices: state.permissions?.partnerServices,
  order: state.orders?.item,
});

const mapDispatchToProps = {
  createVehicleInsurancePolicy: actions.createVehicleInsurancePolicy,
  updateVehicleInsurancePolicy: actions.updateVehicleInsurancePolicy,
  deleteVehicleInsurancePolicy: actions.deleteVehicleInsurancePolicy,
};

export default connect(mapStateToProps, mapDispatchToProps)(inject('vehicleStore')(observer(VehicleModal)));
